import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import React, { useState, useCallback, useEffect } from 'react';

import RecaptchaStyles from '../../styles/elements/Recaptcha.module.scss';

const CaptchaButton = ({ onVerifyCaptcha, buttonText, colour, captchaText, setCaptchaText }) => {
  const [verified, setVerified] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const clickHandler = useCallback(async () => {
    if (!executeRecaptcha) {
      return;
    }

    const result = await executeRecaptcha('contact');

    await fetch('/api/recaptcha', {
      method: 'post',
      body: result
    })
      .then((res) => res.json())
      .then((data) => {
        setVerified(data.success);
      })

      .catch((error) => {
        console.error('Error:', error);
      });
  }, [executeRecaptcha]);

  useEffect(() => {
    setCaptchaText(verified);
    return () => {
      setCaptchaText(verified);
    };
  }, [setCaptchaText, verified]);



  return (
    <div className={RecaptchaStyles.button} onClick={clickHandler} style={{ background: colour }}>
      {buttonText}
    </div>
  );
};

export const ReCaptcha = ({ onVerifyCaptcha, buttonText, colour, captchaText, setCaptchaText }) => (
  <GoogleReCaptchaProvider reCaptchaKey="6LeRB6UcAAAAACDOCLEzCbjNnWDnSgVXWRnCE8YZ">
    <CaptchaButton onVerifyCaptcha={onVerifyCaptcha} buttonText={buttonText} colour={colour} captchaText={captchaText} setCaptchaText={setCaptchaText} />
  </GoogleReCaptchaProvider>
);


// Test build
